<div id="login">
  <div class="login-inner text-white scrollbar">
    <div class="content-padding">
      <div class="login-header">
        <!-- <h1 class="login-title"><span><strong>GGG <br/>Mate</strong></span></h1> -->
        <img src="images/harvest_mate_logo_white.png" />
      </div>

      <div class="login-box">
        <div id="form-signup" class="login-form form-open">
          <h2 class="h4">Confirm Sign Up</h2>
          <form (ngSubmit)="confirmSignUp()">
            <div class="fieldwrap fieldwrap_type_input">
              <label class="label-ontop">Verification Code</label>
              <input
                type="text"
                id="code"
                name="code"
                inputmode="numeric"
                autocomplete="one-time-code"
                #codeModel="ngModel"
                [(ngModel)]="code"
              />
            </div>
            <div class="fieldwrap fieldwrap_type_submit">
              <button type="submit" [disabled]="loading">Send code</button>
              <a class="btn__secondary btn-login" routerLink="/signIn">Back</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>